{
	$(document).on('scroll', (e) => {
		const deg = window.scrollY / 200;
		$('#sun').css('transform', `rotate(${deg}deg)`);
	});

	$(document).ready(() => {
		const vel = (id, duration = 500) => $(id).velocity({ opacity: 0, translateY: 0}, {duration: 0}).velocity({ opacity: 1}, {duration: duration * 2}).velocity({ translateY: "-=20%", opacity: 0}, {duration: duration * 4});

		vel('#smell', 800);
		vel('#smell-left', 500);
		setInterval(() => {
			vel('#smell', 800)
		}, 900 * 6);
		setInterval(() => {
			vel('#smell-left', 500);
		}, 900 * 6);

		$('b.count').counterUp({ delay: 10, time: 800 });

		var sr = ScrollReveal();
		sr.reveal('.sr');
	});
}